import React, { useState, useEffect } from "react";
import confetti from "canvas-confetti";
import MysteryBox from "./MysteryBox"; // Assurez-vous que le composant MysteryBox est bien importé

const TestMysteryBox = () => {
    const [flipped, setFlipped] = useState(false); // Flip state
    const [attemptsLeft, setAttemptsLeft] = useState(6); // Nombre d'essais
    const [showResult, setShowResult] = useState(false); // Afficher le résultat
    const [points, setPoints] = useState(0); // Points gagnés
    const [isCooldown, setIsCooldown] = useState(false); // Gérer l'état de cooldown

    // Fonction de gestion du clic sur la box (flip)
    const handleBoxClick = () => {
        // Retourner la box seulement si elle n'a pas encore été ouverte et si on a des essais restants
        if (attemptsLeft > 0 && !flipped) {
            setFlipped(true);
            setShowResult(false); // Réinitialiser le résultat à chaque flip
            setIsCooldown(true); // Activer le cooldown
            // Diminuer les tentatives
            setAttemptsLeft((prev) => prev - 1);
        }
    };

    // Fonction de gestion du clic sur une mini-box
    const handleMiniBoxClick = () => {
        // Afficher le résultat et confettis après le clic
        const reward = getRandomPrize(); // Calculer un prix aléatoire
        setPoints(reward);
        setShowResult(true);

        // Lancer des confettis
        confetti({
            particleCount: 150,
            spread: 90,
            origin: { x: 0.5, y: 0.5 },
        });

        // Retourner la boîte à la face avant après 3 secondes
        setTimeout(() => {
            setFlipped(false); // Retourner la boîte après 3 secondes
            setIsCooldown(false); // Désactiver le cooldown
            setShowResult(false); // Cacher le résultat
        }, 3000);
    };

    // Fonction pour générer un prix aléatoire
    const getRandomPrize = () => {
        // Exemple de logique pour obtenir un prix aléatoire
        return Math.floor(Math.random() * 10000);
    };

    return (
        <div
            className="flip-card w-full h-full min-h-[265px] cursor-pointer rounded-lg shadow-lg hover:scale-[1.02] hover:shadow"
            onClick={handleBoxClick}
        >
            <div className={`flip-card-inner ${flipped ? "flip" : ""}`}>
                {/* Face avant */}
                <div className="flip-card-front bg-white shadow-lg rounded-lg px-2 py-2 border border-gray-200 flex flex-col items-center h-full min-h-[250px] text-center transition-transform hover:scale-[1.02] hover:shadow-xl">
                    <img
                        src="/dist/image/Isometric-Gift.png"
                        className="h-24 w-full mb-3 object-contain"
                    />
                    <div className="text-center flex flex-col flex-grow justify-between w-full">
                        <div>
                            <div className="sm:!text-sm md:!text-base font-semibold text-black">
                                Défi quotidien
                            </div>
                            <div className="sm:!text-sm md:!text-sm text-gray-600 mt-2 mb-3">
                                Tentez de gagnez jusqu'à 10 000 points !
                            </div>
                        </div>

                        <div className="w-full px-2 mt-auto pb-5">
                            <div className="text-xs text-gray-500 mb-0.5 text-center">
                                {attemptsLeft}/4
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden mb-3">
                                <div
                                    className="bg-gradient-to-l from-blue-500 to-indigo-900 h-full rounded-full transition-all duration-300"
                                    style={{
                                        width: `${(attemptsLeft / 4) * 100}%`,
                                    }}
                                />
                            </div>
                            <div className="sm:!text-sm md:!text-sm font-medium text-black leading-8 mt-auto flex items-center justify-center text-center">
                                ...
                                <img
                                    src="/dist/image/Fav-Infinexia-512x512.webp"
                                    className="w-4 h-4 ml-1 -mt-0.5"
                                    alt="icon"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Face arrière avec les mini-boxes */}
                <div className="flip-card-back bg-white shadow-lg rounded-lg border flex flex-col items-center h-full min-h-[250px] overflow-hidden">
                    <div className="relative w-full h-full">
                        {!showResult ? (
                            <MysteryBox
                                onComplete={handleMiniBoxClick} // Déclenche la logique de récompense et confettis
                            />
                        ) : (
                            <div className="absolute inset-0 bg-white flex items-center justify-center z-10 rounded-xl"></div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TestMysteryBox;
